import { render, staticRenderFns } from "./Loader.vue?vue&type=template&id=57c73e23&scoped=true&"
var script = {}
import style0 from "./Loader.vue?vue&type=style&index=0&id=57c73e23&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57c73e23",
  null
  
)

export default component.exports